import { render, staticRenderFns } from "./user-groups.vue?vue&type=template&id=644e107e&"
import script from "./user-groups.vue?vue&type=script&lang=js&"
export * from "./user-groups.vue?vue&type=script&lang=js&"
import style0 from "./user-groups.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports